export default __webpack_public_path__ + "static/media/what-we-do-big-ellipse.04136cb2.svg";